/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { RetailGroupDto } from './retailGroupDto.schema';

export const IReadOnlyListOfRetailGroupDto = zod.array(zod.lazy(() => RetailGroupDto));

export type IReadOnlyListOfRetailGroupDto = zod.input<typeof IReadOnlyListOfRetailGroupDto>;
export type IReadOnlyListOfRetailGroupDtoOutput = zod.output<typeof IReadOnlyListOfRetailGroupDto>;
